var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jobs-select-dialog',{attrs:{"title":"Add this Candidate to the following Opportunity Queue(s)?","actionButtonText":"Add","value":_vm.value,"jobs":_vm.jobs,"loading":_vm.loading},on:{"action":_vm.onActionClick,"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }